<template>
	<Modal title="忘记密码"  @on-cancel="handleReset">
		<Form ref="formItem" :model="formItem"  :rules="ruleInline" :label-width="80">
			<FormItem label="手机" prop="tel">
				<Input v-model="formItem.tel" placeholder="请输入手机" style="width: 265px;"></Input>
				<Button class="sendcode" type="primary" @click="sendCode">发送手机验证码</Button>
			</FormItem>
			<FormItem label="验证码" prop="code">
				<Input v-model="formItem.code" placeholder="请输入短信验证码"></Input>
			</FormItem>
			<FormItem label="新密码" prop="password">
				<Input v-model="formItem.password" placeholder="请输入密码" type="password"></Input>
			</FormItem>
			<FormItem label="确认密码" prop="passcheck">
				<Input v-model="formItem.passcheck" placeholder="请输入密码" type="password"></Input>
			</FormItem>
		</Form>
		<template #footer>
			<Button type="primary" @click="handleSubmit" :loading="loading">
				提交
			</Button>
			<Button @click="handleReset">
				取消
			</Button>
		</template>
	</Modal>
</template>

<script>
	export default{
		data(){
			const validatePassCheck = (rule, value, callback) => {
				if (value !== this.formItem.password) {
					callback(new Error('确认密码与密码不一致，请重新输入'));
				} else {
					callback();
				}
			};
			return {
				modal: false,
				loading: false,
				formItem: {
					password: '',
					passcheck:'',
					tel: '',
					code: ''
				},
				ruleInline: {
					password: [
						{ required: true, message: '密码不能为空', trigger: 'blur' },
						{ type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' }
					],
					passcheck: [
						{ required: true, message: '密码不能为空', trigger: 'blur' },
						{ type: 'string', min: 6, message: '密码不能少于6位', trigger: 'blur' },
						{ validator: validatePassCheck, trigger: 'blur' }
						
					],
					tel: [
						{ required: true, message: '手机不能为空', trigger: 'blur' },
						{ type: 'string', pattern: /^\d{11}$/, message: '请输入正确的手机号', trigger: 'blur' },
					],
					code: [
						{ required: true, message: '手机验证码不能为空', trigger: 'blur' },
						{ type: 'string', len: 5, message: '请输入正确的手机验证码', trigger: 'blur' },
					]
				}
			}
		},
		methods: {
			handleSubmit() {
				this.$refs['formItem'].validate((valid) => {
					if (valid) {
						this.loading = true;
						this.$axios.post('/user/forget', this.formItem).then((res) => {
							let data = res.data;
							if(data.code == 200){
								this.modal = false;
								this.$Message.success({content:data.msg,onClose:()=>{this.$router.push('/');}});
							}else{
								this.$Message.error({content:data.msg});
							}
							this.loading = false;
						});
					}
				})
			},
			handleReset() {
				this.$refs['formItem'].resetFields();
				this.modal = false;
			},
			sendCode(){
				this.$refs['formItem'].validateField('tel',(valid)=>{
					if(valid == ''){
						this.$axios.post('/user/getcode', {tel:this.formItem.tel}).then((res) => {
							let data = res.data;
							if(data.code == 200){
								this.$Message.success({content:data.msg});
								this.modal = false;
							}else{
								this.$Message.error({content:data.msg});
							}
						});
					}
				});
			}
		},
		computed: {
			IsLogin() {
				if(this.$store.state.jwt != ''){
					return true;
				}else{
					return false;
				}
			}
		}
	}
</script>

<style>
</style>